import { useEffect, useState } from 'react'

/**
 * Returns true only after `eligible` has been continuously true for `delayMs`.
 * Resets immediately to false when `eligible` becomes false.
 */
export function useDelayedVisibility(
  eligible: boolean,
  delayMs: number
): boolean {
  const [delayElapsed, setDelayElapsed] = useState(false)

  useEffect(() => {
    if (!eligible) {
      setDelayElapsed(false)
      return undefined
    }
    const timer = setTimeout(() => setDelayElapsed(true), delayMs)
    return () => clearTimeout(timer)
  }, [eligible, delayMs])

  return delayElapsed
}
